import { Component, Input, HostListener } from '@angular/core';
import { Store } from '@ngrx/store';
import { SetActiveAccount } from '../../../state/profile/actions';
import { GameDayRootReducerState } from '../../../state/root.state';

const linkTypeAttributeName = 'data-profile-overview-link-type';
const linkTextAttributeName = 'data-profile-overview-link-text';
const supportedTypesRe = /^account$/i;

export function getLink(target: Element): Element {
  while (target) {
    if (isLink(target)) {
      return target;
    }

    target = target.parentElement;
  }

  return undefined;
}

function isLink(element: Element): boolean {
  return (
    !!element &&
    element.tagName === 'A' &&
    isLinkTypeSupported(element.getAttribute(linkTypeAttributeName))
  );
}

function isLinkTypeSupported(linkType: string): boolean {
  return supportedTypesRe.test(linkType);
}

@Component({
  selector: 'muni-gameday-profile-overview-open-link',
  templateUrl: './profile-link.template.html',
  styleUrls: ['./profile-link.styles.scss']
})
export class ProfileLinkComponent {
  @Input()
  public text: string;

  @Input()
  public cropped = true;

  @Input()
  public displayText = true;

  @Input()
  public linkType: 'account' | 'manager' | undefined;

  @HostListener('click', ['$event'])
  public onLinkClick(e: MouseEvent): void {
    const link: Element = getLink(e.target as Element);

    if (!link) return;

    e.preventDefault();

    const text: string = link.getAttribute(linkTextAttributeName);
    this.store.dispatch(new SetActiveAccount(text));
  }

  constructor(private store: Store<GameDayRootReducerState>) {}

  public get isLink(): boolean {
    return isLinkTypeSupported(this.linkType);
  }
}
